export const API = {
    COMPANY_HISTORY: `/api/history`,
    STANDARD_YEAR: `/api/standard`,
    PRODUCT: `/api/product`,
    SOLUTION: `/api/solution`,
    PRODUCT_TITLE: `/api/product/title`,
    SOLUTION_TITLE: `/api/solution/title`,
    PRODUCT_DETAIL: `/api/productDetail`,
    CUSTOMER_POST: `/api/post`,
    VIDEO: `/api/youtube`,
    CERTIFICATION: `/api/certification`,
};
